// ENTITIES
import { IProtocoloFic as IRequestProtocoloFic } from 'pages/iirgd/RgFicDigital/StatusCadastro/Buttons/ImprimirProtocolo/functions';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, IProtocoloFic } from './types';

export function protocoloFicRequest(
	token: string,
	payload: IRequestProtocoloFic,
): ReducerActionRotaSP {
	return {
		type: Types.PROTOCOLO_FIC_REQUEST,
		token,
		payload,
	};
}
export function protocoloFicSuccess(
	payload: IProtocoloFic,
): ReducerActionRotaSP {
	return {
		type: Types.PROTOCOLO_FIC_SUCCESS,
		payload,
	};
}
export function protocoloFicFailure(): ReducerActionRotaSP {
	return {
		type: Types.PROTOCOLO_FIC_FAILURE,
		payload: null,
	};
}
export function protocoloFicClear(): ReducerActionRotaSP {
	return {
		type: Types.PROTOCOLO_FIC_CLEAR,
		payload: null,
	};
}
